(function(window, mL, mL_errors, mL_events, mL_config) {
    "use strict";

    var key = 'ipost';

    function safe_start() {
        if (mL_config.do_not_track || !mL_config.tags || !mL_config.tags.ipost || mL_config.is_loc) return;

        var debug_hooks = {
            'debug_ipost': true,
            'debug_analytics': true,
            'debug': true
        };

        var _debug = mL_config.mode && debug_hooks[mL_config.mode];

        function get_item(item) {
            if (!item) return;
            var o = {
                Sku: item.sku,
                Title: item.name || item.storedisplayname,
                //Collection: []
            };

            if (item.quantity) o.Quantity = item.quantity;

            if (item.rate) {
                o.Price = parseFloat(item.rate).toFixed(2);
            } else if (item.price) {
                o.Price = parseFloat(item.price).toFixed(2);
            }

            if (item.shop_name) {
                o.Collection = o.Collection || [];
                o.Collection.push(item.shop_name);
            } else if (item.filters && item.filters.shop_name) {
                o.Collection = o.Collection || [];
                o.Collection.push(item.filters.shop_name);
            }

            if (item.collection_name) {
                o.Collection = o.Collection || [];
                o.Collection.push(item.collection_name);
            } else if (item.filters && item.filters.collection_name) {
                o.Collection = o.Collection || [];
                o.Collection.push(item.filters.collection_name);
            }

            if (item.brand) {
                o.Brand = item.brand;
            } else if (item.filters && item.filters.brand) {
                o.Brand = item.filters.brand;
            }
            return o;
        }

        function get_ipost_date() {
            return new Date().toISOString().split('.')[0].replace('T', ' ');
        }

        /*

        mL_events.subscribe('page', function(msg, data_in) {

            if (mL_config.AUDIT) console.log('pubsub ' + key + ' - ' + msg, data_in);

            if (_debug) console.log(key + ' - ' + msg, { msg: msg, data_in: data_in });
        });
        */

        mL_events.subscribe('order.confirmation', function(msg, data_in) {
            var _order = data_in.order;
            var _order_id = (_order.order_id.indexOf('-') !== -1) ? _order.order_id.split('-')[1] : _order.order_id;

            var _obj = {
                //ConversionPage: encodeURI(window.location.href),
                ConversionPage: 'order_confirmation',
                ConversionType: 'order',
                OrderID: _order_id,
                OrderGrandTotal: _order.revenue,
                OrderDate: get_ipost_date(),
                orderShipping: _order.shipping,
                OrderTax: _order.tax,
                Items: []
            };

            if (_order.promocode && _order.promocode.isvalid) {
                _obj.CouponUsed = _order.promocode.code;
            }

            var i = 0;
            var l = data_in.order.items.length;
            for (i; i < l; i += 1) {
                _obj.Items.push(get_item(data_in.order.items[i]));
            }

            var data_out = { conversion: _obj };

            window.iPostAnalytic.send(data_out);

            if (_debug) console.log(key + ' - ' + msg, { msg: msg, data_in: data_in, data_out: data_out });
        });
        /*

        mL_events.subscribe('form', function(msg, data_in) {
            if (!data_in.data || !data_in.data.email) return;

            var _obj = {
                ConversionPage: encodeURI(window.location.href),
                ConversionType: 'custom',
                EventTitle: data_in.data.eventCategory || 'Email Acquisition',
                ConversionDate: get_ipost_date(),
                Details: [{
                    Title: data_in.data.form || 'unknown',
                    Quantity: '1',
                    Description: data_in.data.email
                }]
            };
            var data_out = { conversion: _obj };

            window.iPostAnalytic.send(data_out);

            if (_debug) console.log(key + ' - ' + msg, data_out);

        });
        */

        mL.ipost = mL.ipost || {};

        function add_iframe(iqs, iframe) {
            iframe = document.createElement('iframe');
            iframe.id = 'ipost_sync';
            iframe.src = 'https://checkout.mlahart.com/checkout/checkout.ssp?iqs=' + mL_config.params.iqs + '&iframe=true';
            iframe.setAttribute('style', 'display:none; width:0px;height:0px;visibility:hidden;');
            document.body.appendChild(iframe);
        }

        mL.ipost.init = function() {

            if (mL.ipost.is_init || !mL.add_tracker) return false;
            // 

            if (mL_config.is_nascar) {
                mL.add_tracker('https://js.g001.enterprise.ipost.com/static/pref/img/client/m/mlahartco/WEH/iPost-Web-Tracking-mor8c5k69oncdtkcli60-V1.js', key + '_nascar');
            } else if (mL_config.is_checkout) {
                mL.add_tracker('https://js.g001.enterprise.ipost.com/static/pref/img/client/m/mlahartco/WEH/iPost-Web-Tracking-mor8c5k69oncdtkclg60-V1.js', key + '_checkout');
                //mL.add_tracker('https://js.g001.enterprise.ipost.com/static/pref/img/client/m/mlahartpartner/WEH/iPost-Web-Tracking-mor8c5k69on0t1ie5pracjkclim0-V1.js', key + '_checkout_partner');
            } else {
                mL.add_tracker('https://js.g001.enterprise.ipost.com/static/pref/img/client/m/mlahartco/WEH/iPost-Web-Tracking-mor8c5k69oncdtkc5ie0-V1.js', key + '_mlahart');
                //mL.add_tracker('https://js.g001.enterprise.ipost.com/static/pref/img/client/m/mlahartpartner/WEH/iPost-Web-Tracking-mor8c5k69on0t1ie5pracjkclgm0-V1.js', key + '_mlahart_partner');
            }

            mL.ipost.is_init = true;

            if (mL_config.params && mL_config.params.iqs) add_iframe(mL_config.params.iqs);

            if (mL_config.DEBUG) console.log(key + ' - plugin loaded');

        };

    }

    try {
        safe_start();
    } catch (err) {
        mL_errors(new Error('safe_start failed - ' + key.toUpperCase()));
        mL_errors(err);
    }


}(window, window.mL, window.mL_errors, window.mL_events, window.mL_config));
// ?mode=debug_ipost
// ?mode=reset